// removed by extract-text-webpack-plugin
module.exports = {"wrapper-page-order":"magazines_1ei7x","wrapper-page-order__active":"magazines_23V33","wrapper-page-order__title":"magazines_3W3y6","wrapper-page-order__pages":"magazines_3cNat"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Editor/components/PageOrder/styles.scss
// module id = 1260
// module chunks = 1